module.exports = __webpack_public_path__ + "img/curved6.f5b4384b.jpg";